import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useEffect, useRef } from "react";
import isEqual from "react-fast-compare";
import { List, WindowScroller } from "react-virtualized";
import { GalleryViewBox } from "./GalleryViewBox";
import { calculateListRowHeight } from "./utils/calculateListRowHeight";
import { sectionsToRows } from "./utils/sectionsToRows";
const itemRenderer = (param, isVisible)=>{
    let { box, render, index } = param;
    return /*#__PURE__*/ _jsx(GalleryViewBox, {
        box: box,
        render: render,
        index: index,
        isVisible: isVisible
    }, index);
};
/**
 * This component displays Gallery view
 */ export const GalleryView = /*#__PURE__*/ memo((param)=>{
    let { scrollElementRef, sections, width, style, rowRenderer } = param;
    const rows = sectionsToRows(sections);
    const listRef = useRef(null);
    useEffect(()=>{
        var _listRef_current;
        (_listRef_current = listRef.current) === null || _listRef_current === void 0 ? void 0 : _listRef_current.recomputeRowHeights();
    }, [
        rows
    ]);
    const getRowHeight = useCallback((param)=>{
        let { index } = param;
        return calculateListRowHeight({
            index,
            rows
        });
    }, [
        rows
    ]);
    return scrollElementRef.current ? /*#__PURE__*/ _jsx(WindowScroller, {
        scrollElement: scrollElementRef.current,
        children: (param)=>{
            let { scrollTop, isScrolling } = param;
            return /*#__PURE__*/ _jsx(List, {
                height: "object" !== "undefined" ? window.innerHeight : 0,
                width: width,
                isScrolling: isScrolling,
                scrollTop: scrollTop,
                rowCount: rows.length,
                tabIndex: -1,
                autoHeight: true,
                ref: listRef,
                rowHeight: getRowHeight,
                rowRenderer: (param)=>{
                    let { index, style, isVisible } = param;
                    const row = rows[index];
                    if (!row) {
                        return /*#__PURE__*/ _jsx("div", {
                            style: {
                                background: "white",
                                width: 100,
                                height: 100
                            }
                        }, index);
                    }
                    return rowRenderer ? rowRenderer({
                        index,
                        style,
                        isVisible,
                        itemRenderer,
                        row
                    }) : /*#__PURE__*/ _jsx("div", {
                        style: style,
                        children: row.map((item)=>itemRenderer(item, isVisible))
                    }, index);
                },
                style: style,
                overscanRowCount: 2
            });
        }
    }) : null;
}, isEqual);
GalleryView.displayName = "GalleryView";
